(() => {
  const isPrivacyPage = () =>
    /^\/policies\/privacy-policy\/?$/.test(location.pathname);

  if (!isPrivacyPage()) return;

  const NEW_CONTACT_TEXT =
    'If you have any questions about our privacy practices or this Privacy Policy, or if you wish to exercise any of your rights, you may contact us by email at elizna@elizna.com or via WhatsApp only at +1 307-533-7925.';

  // IMPORTANT V3 FIX:
  // Only a single <p> may be replaced. Never replace a DIV/container,
  // otherwise the full policy can be destroyed in the rendered DOM.
  const replaceExactContactParagraph = (scope) => {
    if (!scope) return;

    const paragraphs = [...scope.querySelectorAll('p')];

    const oldContact = paragraphs.find((p) => {
      const t = (p.textContent || '').replace(/\s+/g, ' ').trim();

      return (
        t.includes('mcetinkaya@novarahub.us') ||
        t.includes('30 N Gould St') ||
        (
          t.includes('+1 307-533-7925') &&
          /should you have any questions|privacy practices|exercise any of the rights/i.test(t)
        )
      );
    });

    if (oldContact) {
      oldContact.textContent = NEW_CONTACT_TEXT;
      oldContact.classList.add('elizna-policy-contact-v3');
    }
  };

  const buildPresentation = () => {
    const body = document.querySelector('.shopify-policy__body');
    const rte = body?.querySelector('.rte');

    if (!body || !rte) return;

    document.body.classList.add('elizna-privacy-policy-pro');

    // Correct only the contact paragraph in the ORIGINAL policy DOM first.
    replaceExactContactParagraph(rte);

    // If V3 has already built the layout, do nothing further.
    if (rte.querySelector('.elizna-policy-layout')) {
      replaceExactContactParagraph(rte);
      return;
    }

    // Preserve EVERY original node from Shopify's legal policy.
    const article = document.createElement('div');
    article.className = 'elizna-policy-article';

    [...rte.childNodes].forEach((node) => article.appendChild(node));

    // A second safe paragraph-only pass after moving the original nodes.
    replaceExactContactParagraph(article);

    const headings = [...article.querySelectorAll('h2')];

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const slug = (heading.textContent || `section-${index + 1}`)
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');

        heading.id = `privacy-${slug || index + 1}`;
      }
    });

    const paragraphs = [...article.querySelectorAll('p')];

    const updated = paragraphs.find((p) =>
      /^\s*last updated\s*:/i.test(p.textContent || '')
    );
    if (updated) updated.classList.add('elizna-policy-last-updated');

    const intro = paragraphs.find(
      (p) => p !== updated && (p.textContent || '').trim().length > 80
    );
    if (intro) intro.classList.add('elizna-policy-intro');

    const nav = document.createElement('aside');
    nav.className = 'elizna-policy-nav';
    nav.setAttribute('aria-label', 'Privacy policy contents');

    const navItems = headings.map((heading, index) => `
      <li>
        <a href="#${heading.id}">
          <span class="elizna-policy-nav__index">${String(index + 1).padStart(2, '0')}</span>
          <span>${heading.textContent.trim()}</span>
        </a>
      </li>
    `).join('');

    nav.innerHTML = `
      <p class="elizna-policy-nav__eyebrow">Policy Index</p>
      <h2 class="elizna-policy-nav__title">Privacy, clearly organised.</h2>
      <ol class="elizna-policy-nav__list">${navItems}</ol>
      <p class="elizna-policy-nav__note">
        This page presents ELIZNA™’s privacy policy in a structured reading format.
        The legal policy content remains sourced from Shopify.
      </p>
    `;

    const layout = document.createElement('div');
    layout.className = 'elizna-policy-layout';
    layout.append(nav, article);

    rte.appendChild(layout);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildPresentation);
  } else {
    buildPresentation();
  }

  document.addEventListener('shopify:section:load', buildPresentation);
})();
